import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonAdvancedComponent } from './button-advanced/button-advanced.component';
import { ButtonIconComponent } from './button-icon/button-icon.component';
import { ButtonBaseComponent } from './button-base.component';
import { ButtonOutlineComponent } from './button-outline/button-outline.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    ButtonBaseComponent,
    ButtonAdvancedComponent,
    ButtonIconComponent,
    ButtonOutlineComponent,
  ],
  declarations: [
    ButtonBaseComponent,
    ButtonAdvancedComponent,
    ButtonIconComponent,
    ButtonOutlineComponent,
  ],
})
export class CustomButtonsModule {}
